import { AxiosResponse } from 'axios';
import { ICommandResponseData } from 'types/net';

export function extractResponseData<T>(response: AxiosResponse): T {
  return response.data as T;
}

export async function handleCommandResponseData<T>(response: AxiosResponse): Promise<T> {
  const commandData: ICommandResponseData = response.data;

  if (!commandData.success) {
    throw new Error(commandData.message);
  }

  return commandData.data as T;
}

export function handleDownloadFileResponse(res: AxiosResponse, defaultFileName: string = 'file') {
  const href = URL.createObjectURL(res.data);
  const link = document.createElement('a');
  const fileName = res.headers['content-disposition']?.match(/filename="?([^"]*)"?;/)?.[1] || `${defaultFileName}.xlsx`;

  link.href = href;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}

export function createDefaultURLSearchParams(query: Record<string, unknown>) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([param, value]) => {
    params.set(param, value as string);
  });
  return params;
}

export function parseQuerySortingProps(
  field: string,
  sortingValue: unknown,
): { active: boolean; direction: 'asc' | 'desc' } {
  const fieldIndex = (sortingValue as string[] | undefined)?.findIndex(sorting => sorting.startsWith(field)) as number;

  if (fieldIndex > -1) {
    let [parsedField, parsedDirection] = (sortingValue as string[] | undefined)![fieldIndex].split(':') as [
      string,
      'desc' | 'asc',
    ];
    return {
      active: parsedField === field,
      direction: parsedDirection,
    };
  }

  return {
    active: false,
    direction: 'desc',
  };
}
